/*
 *
 * OperationCustomerInfo
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 04-Dec-2025
 */

import React from 'react'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  billingAddress: <PortalMessage id='t.app.orders.tab.billingAddress' defaultMessage='Billing Address' />,
  shippingAddress: <PortalMessage id='t.app.orders.tab.shippingAddress' defaultMessage='Shipping Address' />,
  name: <PortalMessage id='t.app.orders.billing.name' defaultMessage='Name' />,
  street: <PortalMessage id='t.app.orders.billing.street' defaultMessage='Street' />,
  additionalInfo: <PortalMessage id='t.app.orders.billing.additionalInfo' defaultMessage='Additional info' />,
  city: <PortalMessage id='t.app.orders.billing.city' defaultMessage='City' />,
  postCode: <PortalMessage id='t.app.orders.billing.postCode' defaultMessage='Postal code' />,
  province: <PortalMessage id='t.app.orders.billing.province' defaultMessage='Province' />,
  country: <PortalMessage id='t.app.orders.billing.country' defaultMessage='Country' />,
  cardHolderName: <PortalMessage id='t.app.orders.customer.cardHolderName' defaultMessage='Name' />,
  cardHolderEmail: <PortalMessage id='t.app.orders.customer.cardHolderEmail' defaultMessage='Email' />,
  mobilePhone: <PortalMessage id='t.app.orders.customer.mobilePhone' defaultMessage='Mobile Phone' />,
  tin: <PortalMessage id='t.app.orders.customer.tin' defaultMessage='Tax Identification Number' />,
  recontactConsent: (
    <PortalMessage id='t.app.orders.customer.recontactConsent' defaultMessage='Recontact consent' /> 
  ),
  no: <PortalMessage id='t.app.operationsmanagement.research.advancedSettings.no' defaultMessage='No' />,
  yes: <PortalMessage id='t.app.operationsmanagement.research.advancedSettings.yes' defaultMessage='Yes' />
}

export default formattedMessage
